import { IChain } from "sagas/chainSaga";

export enum ChainActionTypes {
  FETCH_CHAIN_REQUEST = "FETCH_CHAIN_REQUEST",
  FETCH_CHAIN_SUCCESS = "FETCH_CHAIN_SUCCESS",
  FETCH_CHAIN_FAILURE = "FETCH_CHAIN_FAILURE",
}

// Action interfaces
export interface FetchChainRequestAction {
  type: ChainActionTypes.FETCH_CHAIN_REQUEST;
}

export interface FetchChainSuccessAction {
  type: ChainActionTypes.FETCH_CHAIN_SUCCESS;
  payload: IChain;
}

export interface FetchChainFailureAction {
  type: ChainActionTypes.FETCH_CHAIN_FAILURE;
  payload: string;
}

// Action creators
export const fetchChainRequest = (): FetchChainRequestAction => ({
  type: ChainActionTypes.FETCH_CHAIN_REQUEST,
});

export const fetchChainSuccess = (data: IChain): FetchChainSuccessAction => ({
  type: ChainActionTypes.FETCH_CHAIN_SUCCESS,
  payload: data,
});

export const fetchChainFailure = (error: string): FetchChainFailureAction => ({
  type: ChainActionTypes.FETCH_CHAIN_FAILURE,
  payload: error,
});

export type ChainActions =
  | FetchChainRequestAction
  | FetchChainSuccessAction
  | FetchChainFailureAction;
